// extracted by mini-css-extract-plugin
export default {"tcText":"AboutUs_tcText__GJU-5","aboutUsContainer":"AboutUs_aboutUsContainer__NU45u","containerText":"AboutUs_containerText__4L6qR","containerIcon":"AboutUs_containerIcon__3ibe-"};